import { Pagination, Spin } from "antd";
import { useContext, useEffect } from "react";
import List from "./List";
import mainContext from "../context/MainContext/mainContext";
import { FaInbox } from "react-icons/fa";
const BillingContentCompleted = () => {
  const {
    searchQuery,
    pageSize,
    pageNumber,
    setPageNumber,
    setPageSize,
    fetchBillings,
    billings,
    fetchToggle,
    searchToggle,
    loading,
    totalOrders,
    preservePageNumberOnNextListMount,
    setPreservePageNumberOnNextListMount,
    financialYear,
  } = useContext(mainContext);

  const handlePageChange = (page, size) => {
    setPageNumber(page);
    setPageSize(size);
  };

  // const fetchAndLogSalesOrders = async () => {
  //   const response = await fetchBillings();
  //   console.log("API Response:", response);
  // };

  useEffect(() => {
    if (preservePageNumberOnNextListMount) {
      setPreservePageNumberOnNextListMount(false);
    } else {
      setPageNumber(1);
    }
  }, []);

  useEffect(() => {
    fetchBillings("completed");
  }, [pageNumber, pageSize, fetchToggle, financialYear]);

  const filteredOrders = billings?.filter(
    (order) => order.billingConfirmed === true
  );

  useEffect(() => {
    const totalOrdersCount = totalOrders || { pending: 0, completed: 0 };
    const totalCount = searchToggle
      ? filteredOrders?.length || 0
      : totalOrdersCount.completed || 0;

    const totalPages = Math.ceil((totalCount || 0) / (pageSize || 1));
    const safeTotalPages = totalPages > 0 ? totalPages : 1;

    if (pageNumber > safeTotalPages) {
      setPageNumber(safeTotalPages);
    }
  }, [
    totalOrders,
    searchToggle,
    filteredOrders?.length,
    pageSize,
    pageNumber,
    setPageNumber,
  ]);

  const getTotalCount = () => {
    let totalOrdersCount = totalOrders || { pending: 0, completed: 0 };

    let total;

    if (searchToggle) {
      total = filteredOrders.length; // When search is applied, show filtered count
    } else {
      total = totalOrdersCount.completed;
    }

    console.log(`Total Count: ${total}`);
    return total;
  };

  return (
    <div className="salesOrder-tab-list">
      <div className="salesOrder-list-container">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Spin size="large" />
          </div>
        ) : filteredOrders && filteredOrders.length > 0 ? (
          filteredOrders.map((order) => (
            <List key={order._id} order={order} isCompleted={true} />
          ))
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              justifyContent: "center",
              fontSize: "1.5rem",
              fontWeight: "600",
              color: "gray",
              marginBottom: "1rem",
            }}
          >
            <FaInbox /> No Completed Billings yet!
          </div>
        )}

        {!loading && (
          <Pagination
            style={{ margin: "auto" }}
            current={pageNumber}
            pageSize={pageSize}
            total={getTotalCount()}
            onChange={handlePageChange}
            showSizeChanger
            pageSizeOptions={["10", "20", "50"]}
            defaultPageSize={10}
          />
        )}
      </div>
    </div>
  );
};
export default BillingContentCompleted;
